import { IPxHeightData } from "./height-data";
import { IWidgetVisibility, VisibilityData, WidgetPlaceType } from "./index";
import { IAnimatedWidget } from "./widget-style-data";

export interface IMapWidgetData extends IWidgetVisibility {
    readonly type: "MapWidget";
    placeType: WidgetPlaceType;
    id?: string | null;
    addresses: IAddress[];
    zoom: number;
    style: IMapWidgetStyle;
}

export interface IAddress {
    id: string;
    coordinate: ICoordinate;
    title: string;
}

export interface ICoordinate {
    addressName: string;
}

export interface IMapWidgetStyle extends IAnimatedWidget {
    heightData?: IPxHeightData | null;
}

export abstract class MapWidgetData {

    public static get defaultData(): IMapWidgetData {
        return {
            type: "MapWidget",
            placeType: "Section",
            addresses: this.defaultAddresses,
            zoom: 1,
            style: this.defaultStyle,
            visibility: VisibilityData.defaultData()
        };
    }

    public static get defaultAddresses(): IAddress[] {
        return [
            {
                id: "1",
                title: "Adress 1",
                coordinate: {
                    addressName: "1166 W Newport Center Dr ste 209, Deerfield Beach, Florida 33442, USA",
                }
            }
        ];
    }

    public static get defaultStyle(): IMapWidgetStyle {
        return {
            heightData: {
                height: 205
            },
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            }
        };
    }

}
